<!-- MODAL verMovimiento -->
<div mdbModal #verMovimiento="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg modal-dialog-movimiento-maquinas" style="min-width: 80%;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Movimiento de máquinas
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="verMovimiento.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body modal-body-movimiento-maquinas">

        <mdb-spinner spinnerColor="blue" *ngIf="loading"></mdb-spinner>

        <app-no-data-alert *ngIf="listaMovimientos?.length === 0">
        </app-no-data-alert>

        <div class="justify-content-between">

          <app-api-button color="success" [processing]="loadingVoucher" [disabled]="estadoItem === true"
            (click2)="downloadExcelPdfEspecifico('PDF')">
            Baucher
          </app-api-button>
        </div>

        <div class="table-movimiento-maquinas-container" *ngIf="listaMovimientos?.length > 0">
          <table class="table table-striped table-hover table-sm align-middle table-movimiento-maquinas">
            <colgroup>
              <col class="tm-col-fecha-asig" />
              <col class="tm-col-origen" />
              <col class="tm-col-destino" />
              <col class="tm-col-rut" />
              <col class="tm-col-detalle" />
              <col class="tm-col-direccion" />
              <col class="tm-col-fecha-entrega" />
              <col class="tm-col-guia" />
              <col class="tm-col-contrato" />
            </colgroup>
            <thead class="grey lighten-2">
              <tr>
                <th scope="col" class="text-center tm-cell-fecha">Fecha Asig.</th>
                <th scope="col" class="text-center tm-cell-origen-head">Origen</th>
                <th scope="col" class="text-center tm-cell-destino-head">Destino</th>
                <th scope="col" class="text-center tm-cell-rut">Rut</th>
                <th scope="col" class="text-center tm-cell-truncate-head">Detalle Destino</th>
                <th scope="col" class="text-center tm-cell-truncate-head">Dirección</th>
                <th scope="col" class="text-center tm-cell-fecha">Fecha entrega</th>
                <th scope="col" class="text-center tm-cell-guia">Guía Despacho</th>
                <th scope="col" class="text-center tm-cell-contrato">Contrato</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let movimiento of listaMovimientos; let i = index" (click)="ClickedRow(i, movimiento)"
                [class.active]="i == PintarRow">
                <td class="text-center tm-cell-fecha">{{movimiento.fecha_asignacion | fecha}}</td>
                <td class="tm-hover-cell" [ngClass]="{'has-text': movimiento.origen}">
                  <span *ngIf="movimiento.origen" class="tm-hover-text" [tmMarkIfTruncated]="movimiento.origen">
                    {{movimiento.origen}}
                  </span>
                </td>
                <td class="tm-hover-cell" [ngClass]="{'has-text': movimiento.destino}">
                  <span *ngIf="movimiento.destino" class="tm-hover-text" [tmMarkIfTruncated]="movimiento.destino">
                    {{movimiento.destino}}
                  </span>
                </td>
                <td class="tm-cell-rut">
                  <span *ngIf="movimiento.cliente_proveedor_rut === 0"></span>
                  <span
                    *ngIf="movimiento.cliente_proveedor_rut > 0">{{this.rutService.AgregarDV(movimiento.cliente_proveedor_rut)
                    | rut}}</span>
                </td>
                <td class="tm-hover-cell" [ngClass]="{'has-text': movimiento.detalle_destino}">
                  <span *ngIf="movimiento.detalle_destino" class="tm-hover-text"
                    [tmMarkIfTruncated]="movimiento.detalle_destino">
                    {{movimiento.detalle_destino}}
                  </span>
                </td>
                <td class="tm-hover-cell" [ngClass]="{'has-text': movimiento.direccion_nombre}">
                  <span *ngIf="movimiento.direccion_nombre" class="tm-hover-text"
                    [tmMarkIfTruncated]="movimiento.direccion_nombre">
                    {{movimiento.direccion_nombre}}
                  </span>
                </td>
                <td class="text-center tm-cell-fecha">{{movimiento.fecha_entrega | fecha }}</td>
                <td class="text-center tm-cell-guia">
                  {{ movimiento.numero_documento_movimiento || (i === 0 ? fallbackNumeroDocumentoMovimiento : '') }}
                </td>
                <td class="text-center tm-cell-contrato">
                  {{ movimiento.numero_contrato || (i === 0 ? fallbackNumeroContrato : '') }}
                </td>
              </tr>
            </tbody>
            <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)"
              *ngIf="listaMovimientos?.length > 0"></app-pagination>
          </table>
        </div>
      </div>
      <div class="modal-footer justify-content-between">
        <button size="sm" type="button" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
          (click)="CerrarMovimiento(); verMovimiento.hide()" mdbWavesEffect>
          Cerrar
        </button>

        <app-api-button color="success" [processing]="loadingPdf" (click2)="downloadExcelPdf('PDF')">
          PDF
        </app-api-button>
      </div>
    </div>
  </div>
</div>
